import { render, staticRenderFns } from "./VirtualAccountContent.vue?vue&type=template&id=03967194&lang=pug"
import script from "./VirtualAccountContent.vue?vue&type=script&lang=js"
export * from "./VirtualAccountContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports